<template>
  <v-card
    tile
    elevation="1"
  >
    <v-list-item
      v-for="translation in translations"
      :key="`translation-${translation.id}`"
      @click="edit(translation)"
    >
      <template #default>
        <v-list-item-icon>
          <v-icon
            :color="isMissingtranslations(translation) ? 'orange' : 'green'"
            v-text="isMissingtranslations(translation) ? 'mdi-alert-circle' : 'mdi-check-circle'"
          />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ allLanguages[translation.language_code].name }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    translations: {
      type: Array,
      required: true
    },
    allLanguages: {
      type: Object,
      required: true
    },
    missingTranslations: {
      type: Object,
      required: true
    },
    contactFormFields: {
      type: Array,
      required: true
    }
  },

  methods: {
    create() {
      const url = this.route('faq-translation.create', this.faqId);
      this.$inertia.get(url, {}, {
        preserveState: true,
        preserveScroll: true
      });
    },

    isMissingtranslations(translation) {
      let value = false;

      if (this.missingTranslations.faq[translation.language_code]) {
        value = true;
      }

      this.contactFormFields.forEach(field => {
        const fieldMissing = this.missingTranslations.contact_form_fields[field.id];
        if (fieldMissing && fieldMissing[translation.language_code] === true) {
          value = true;
        }
      });

      return value;
    },

    edit(translation) {
      const url = this.route('faq-translation.edit', {
        faq: this.faqId,
        faqTranslation: translation.id
      });

      this.$inertia.get(url, {}, {
        preserveState: true,
        preserveScroll: true
      });
    }
  },
}
</script>